/**
 * Refreshes app blocks in the product section when the selected variant changes.
 *
 * ProductInfo fetches the section with `?section_id=…&option_values=…`, so the
 * response already contains every app block re-rendered for the new variant.
 * However, handleUpdateProductInfo() only copies a fixed list of ids
 * (#price-, #Sku-, #Inventory-, #Volume-, #Price-Per-Item-), so app blocks are
 * left untouched. This module fills that gap by reading the parsed document
 * carried in the `variantChange` event payload.
 *
 * Requires the `[data-app-block]` wrapper rendered around `{% render block %}`
 * in the product section's `@app` case — app blocks cannot carry attributes of
 * their own.
 *
 * Only covers the same-product update path. The combined-listing path
 * (ProductInfo#handleSwapProduct) replaces the whole <product-info> element,
 * so app blocks come along with it.
 */
subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, html } }) => {
  // `sectionId` is ProductInfo's originalSection when present, its section
  // otherwise. Match both so quick-add and duplicated sections don't clobber
  // each other's blocks.
  const productInfo = document.querySelector(
    `product-info[data-section="${sectionId}"], product-info[data-original-section="${sectionId}"]`
  );
  if (!productInfo) return;

  productInfo.querySelectorAll('[data-app-block]').forEach((current) => {
    const updated = html.querySelector(`[data-app-block="${current.dataset.appBlock}"]`);
    if (!updated) return;

    // Skip blocks whose markup didn't change: remounting them would flicker and
    // re-register their listeners for nothing.
    if (updated.innerHTML.trim() === current.innerHTML.trim()) return;

    // setInnerHTML rather than innerHTML: it reinjects <script> tags so app
    // blocks that boot themselves inline still run after the swap.
    HTMLUpdateUtility.setInnerHTML(current, updated.innerHTML);
  });
});
